import type { TwelveMonthExpenseInsightsDTO } from "../models/twelveMonthExpenseInsightsDto";
import type { TwelveMonthExpenseInsightsEntity } from "../../domain/entities/TwelveMonthExpenseInsightsEntity";

export function twelveMonthExpenseInsightsDtoToEntity(
  dto: TwelveMonthExpenseInsightsDTO,
): TwelveMonthExpenseInsightsEntity {
  return {
    insights: (dto.insights ?? []).map((item) => ({
      accentColor: (item.accentColor ?? "neutral") as
        | "success"
        | "warning"
        | "neutral",
      description: item.description ?? "",
    })),
    rangeLabel: dto.range_label ?? "",
    monthCount:
      typeof dto.month_count === "number" && Number.isFinite(dto.month_count)
        ? Math.max(0, Math.floor(dto.month_count))
        : 0,
    noInsights: dto.no_insights ?? false,
    message: dto.message ?? null,
  };
}
